import { createFileRoute } from '@tanstack/react-router'

import { StoreHistoryPage } from '@/features/store'

export const Route = createFileRoute('/_authenticated/_main/loja/historico')({
  component: StoreHistoryPage
})
